import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/actions';
import { i18n } from '../../translate/i18n';
import calendar from '../../assets/Home/calendar.svg'
import action from '../../assets/Home/action.svg'
import contractors from '../../assets/Home/contractors.svg'
import dashboard from '../../assets/Home/dashboard.svg'
import equipments from '../../assets/Home/equipments.svg'
import places from '../../assets/Home/places.svg'
import maps from '../../assets/Home/maps.svg'
import services from '../../assets/Home/services.svg'
import pictograma from '../../assets/Home/pictograma.svg'
import logoGAP from '../../assets/Home/logoGAP.svg'
import avisos from '../../assets/Home/avisos.svg'
import params from '../../assets/Home/params.svg'

import {
	Typography, Paper, useMediaQuery
} from '@mui/material';

import Card from '../../UI/Cards/CardHome';

import { roleNames } from '../../utils/roleNames';

const items = [
	{
		title: i18n.t('items.title'),
		description: i18n.t('items.description'),
		icon: calendar,
		url: 'calendar'
	},
	{
		title: i18n.t('items.title1'),
		description: i18n.t('items.description1'),
		icon: action,
		url: 'actions'
	},
	{
		title: i18n.t('items.title2'),
		description: i18n.t('items.description2'),
		icon: places,
		url: 'admin-places'
	},
	{
		title: i18n.t('items.title3'),
		description: i18n.t('items.description3'),
		icon: maps,
		url: 'admin-maps'
	},
	{
		title: i18n.t('items.title4'),
		description: i18n.t('items.description4'),
		icon: dashboard,
		url: 'powerbi'
	},
	{
		title: i18n.t('items.title5'),
		description: i18n.t('items.description5'),
		icon: equipments,
		url: 'admin-gestao-equip'
	},
	{
		title: i18n.t('items.title6'),
		description: i18n.t('items.description6'),
		icon: services,
		url: 'admin-gestao-servicos'
	},
	{
		title: i18n.t('items.title7'),
		description: i18n.t('items.description7'),
		icon: contractors,
		url: 'admin-empresas'
	},
]

const Home = (props) => {
	const dispatch = useDispatch();
	const { name, selectedAccess } = useSelector(state => state.auth);

  const matches = useMediaQuery('(min-width:45rem)');

	useEffect(() => {
		dispatch(actions.setOpenDrawer(false))
	}, [])
	
  return (
		<div style={{ flexDirection: matches ? 'row' : 'column', ...styles.container, height: window.innerHeight - 128 }}>
			<div style={styles.homeContainer}>
				<div style={styles.detailsContainer}>
					<Typography style={styles.name}>{`${i18n.t('wellcome.phrase1')}, ${i18n.t('wellcome.phrase2')} ${name}!`}</Typography>
					<div style={styles.roleContainer}>
						<Typography style={styles.role}>{roleNames(selectedAccess.role)}</Typography>
						{selectedAccess.role === 'admin' &&
							<Paper style={styles.paramsContainer} onClick={() => props.history.push('admin-usuarios')}>
								<img src={params} style={styles.paramsIcon} />
								<Typography style={styles.paramsText}>{i18n.t('others.param')}</Typography>
							</Paper>}
					</div>
					<div style={styles.pictogramaContainer}>
						<img src={pictograma} style={styles.pictograma} />
					</div>
					<div style={styles.descriptionContainer}>
						<Typography style={styles.description}>
							{matches ? i18n.t('others.matchTrue') : i18n.t('others.matchFalse')}
						</Typography>
						<Typography style={styles.description}>{i18n.t('others.message')}</Typography>
					</div>
					<div style={styles.avisosContainer}>
						<div style={styles.avisosTitleContainer}>
							<img src={avisos} />
							<Typography style={styles.avisosTitle}>{i18n.t('others.infoLabel')}:</Typography>
						</div>
						<Typography style={styles.avisosList}>&#8226; {i18n.t('others.infoMsg')}</Typography>
					</div>
				</div>
				{matches &&
					<a href='http://sistemasgap.com.br/' target='_blank' title='developed by GAP SISTEMAS®'>
						<img src={logoGAP} />
					</a>}
			</div>
			{selectedAccess.role === 'contractor' ?
			<div style={styles.itemsContainer}>
				{items.filter(item => item.title !== 'Empresas Terceiras' && item.title !=='Dashboard').map(item => (
					<Card
						key={item.title}
						{...item}
						{...props}
					/>
				))}
			</div>
			: 
			<div style={styles.itemsContainer}>
			{items.map(item => (
				<Card
					key={item.title}
					{...item}
					{...props}
				/>
			))}
			</div>
		}
		</div>
  );
}

const styles = {
	container: {
		display: 'flex',
		height: '100%',
	},
	homeContainer: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		// minWidth: '25rem',
		justifyContent: 'space-between',
		marginRight: '1rem',
	},
	detailsContainer: {
		display: 'flex',
		flexDirection: 'column',
		marginTop: '0.5rem',
	},
	name: {
		fontSize: '1.5rem',
		fontWeight: 'bold',
	},
	roleContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		// marginTop: '0.5rem',
	},
	role: {
		color: 'grey',
		fontWeight: 'bold',
	},
	itemsContainer: {
		display: 'flex',
		flex: 2,
		flexWrap: 'wrap',
		alignItems: 'stretch',
	},
	pictogramaContainer: {
		display: 'flex',
		justifyContent: 'center',
		padding: '1.5rem 0',
	},
	pictograma: {
		width: '20rem',
	},
	descriptionContainer: {
		display: 'flex',
		flexDirection: 'column',
	},
	description: {
		textAlign: 'center',
		fontSize: '0.85rem'
	},
	avisosContainer: {
		marginBottom: '2rem',
	},
	avisosTitleContainer: {
		display: 'flex',
		alignItems: 'center',
		marginTop: '2rem'
	},
	avisosTitle: {
		fontWeight: 'bold',
		color: '#4F4F4F',
		margin: '0.5rem 0.5rem'
	},
	avisosList: {
		fontSize: '0.8rem',
		marginLeft: '4rem',
	},
	paramsContainer: {
		display: 'flex',
		alignItems: 'center',
		padding: '0.25rem 1rem',
		marginTop: '0.25rem',
		cursor: 'pointer',
	},
	paramsIcon: {
		width: '0.9rem',
	},
	paramsText: {
		color: '#7F7F7F',
		fontSize: '0.9rem',
		marginLeft: '0.25rem'
	}
}

export default Home;
